import { Palette } from 'lucide-react';
import React from 'react';
import { SpotShape, TextShape } from '../../../../../../types';
import { useMapEditor } from '../../../../contexts/MapEditorContext';
import { ShapeControlButton } from './ShapeControlButton';
import { ShapeControlProps } from './types';
import { ColorPickerInput } from '../../../../../ui/ColorPickerInput';

export const ShapeControlColor: React.FC<ShapeControlProps> = ({
  shape,
  onUpdate
}) => {
  const { disableHistoryRecording, enableHistoryRecording, highlightedShape } =
    useMapEditor();
  const selectedColor = React.useRef<string | null>(null);
  const handleColorChange = (color: string) => {
    selectedColor.current = color;
    if (shape.type === 'text') {
      onUpdate({ textColor: color });
    } else {
      onUpdate({ color });
    }
  };

  const defaultColor =
    shape.type === 'spot' ? (shape as SpotShape).rectProps?.color : shape.color;

  const _selectedColor = React.useMemo(() => {
    if (highlightedShape && shape) {
      return (shape as SpotShape).rectProps?.color;
    }

    if (shape.type === 'text') {
      return (shape as TextShape).textColor;
    }

    return shape.color || defaultColor;
  }, [highlightedShape, defaultColor, shape]);

  return (
    <ColorPickerInput
      trigger={
        <ShapeControlButton title={'Change color'} icon={Palette}>
          <div
            className="h-4 w-4 rounded-full border border-gray-200"
            style={{
              backgroundColor: _selectedColor || ''
            }}
          />
        </ShapeControlButton>
      }
      value={_selectedColor || ''}
      onChange={handleColorChange}
      showInput={false}
      triggerAsChild={false}
    />
  );
};
